import React from "react";
import CollapsibleParagraph from "../CollapsibleParagraph.js";

const Myths = () => {
	return (
		<section id="myths">
			<div className="mi-invert">
				<div className="container mil-p-120-0">
					<div className="mil-mb-60">
						<div className="mil-complex-text mil-mb-15">
							<div className="mil-h3 mil-start">
                 				MÝTY O INVESTOVÁNÍ DO NEMOVITOSTI
							</div>
						</div>
					</div>
					<div className="row mil-mb-60 ps-4">
						<div className="col-12">
							<CollapsibleParagraph title={"“Nemovitost v Praze je pro běžného člověka finančně nedostupná.“"}
								children={<span>
									Není to pravda! Díky využití principu finanční páky a našemu modelu je vlastní
									investiční byt dostupný i pro vás. Hypotéka v podstatě dělá z běžného člověka
									podnikatele, aniž by musel disponovat geniálním nápadem nebo velkým majetkem.
								</span>
								} />
							<CollapsibleParagraph title={"“Investice do nemovitostí je složitá.“"}
								children={<span>
									S námi ne. S NEGARSONKOU se nemusíte starat o hledání vhodného bytu,
									rekonstrukci ani řešení s dodavateli – vše zařídíme za vás. Najdeme vám vhodný
									byt, zajistíme její rekonstrukci a usnadníme celý proces. Vy si pouze zajistíte
									financování, a za pár týdnů máte hotovou investiční nemovitost připravenou k
									pronájmu nebo prodeji.
								</span>
								} />
							<CollapsibleParagraph title={"“Hypotéka je velký závazek.“"}
								children={<span>
									Naopak, je to způsob, jak nechat peníze banky pracovat pro vás. Na počátku období
									splácení může být rozdíl mezi nájmem a splátkou hypotéky relativně malý, ale díky
									dlouhodobě rostoucím nájmům a přirozenému poklesu reálné hodnoty splátek v
									důsledku inflace se tento rozdíl postupem času zvětšuje.
								</span>
								} />
							<CollapsibleParagraph title={"“Malé byty nejsou pohodlné ani výnosné.“"}
								children={<span>
									Malé byty jsou investičním klenotem – nízká pořizovací cena, vysoká poptávka po
									pronájmu a maximální využití prostoru znamenají stabilní a dlouhodobý výnos. Díky
									chytrému designu NEGARSONKY navíc získáte atraktivní nemovitost, která se
									pronajímá rychleji a s minimální fluktuací nájemníků.
								</span>
								} />
							<CollapsibleParagraph title={"“Lepší je investovat do akcií. Je to výnosnější a krátkodobější.“"}
								children={<span>
									Investice do nemovitosti skrz hypotéku nabízí stabilitu, dlouhodobý růst hodnoty a
									možnost využití finanční páky, což znamená, že s menším vlastním kapitálem
									můžete ovládat hodnotnější aktivum. Na rozdíl od akcií nemovitost poskytuje
									hmatatelnou hodnotu, možnost pasivního příjmu z pronájmu a ochranu proti inflaci.
									Navíc úrok z hypotéky lze často odečíst z daní, což zlepšuje celkovou návratnost
									investice.
								</span>
								} />
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Myths;
